import { INGREDIENTS_TREE_RDB } from '__constants__'
import PropTypes from 'prop-types'

/**
 * Returns the path up to the specified id in the given path.
 *
 * @param {string} path - The path to search in.
 * @param {string} id - The id to search for.
 * @returns {string} - The path up to the specified id, or the entire path if the id is the last segment.
 */
const getPathUpToId = (path, id) => {
  const idIndex = path.indexOf(`/${id}`)
  if (idIndex !== -1) {
    // Found the id in the path
    const nextSlashIndex = path.indexOf('/', idIndex + 1)
    if (nextSlashIndex !== -1) {
      // There's more path after the id, return up to this point
      return path.substring(0, nextSlashIndex)
    } else {
      // The id is the last segment, return the entire path
      return path
    }
  } else {
    // Id not found in the path
    return INGREDIENTS_TREE_RDB
  }
}

getPathUpToId.propTypes = {
  path: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
}

export default getPathUpToId
